import React, { useState } from "react";
import { Message, MessageProps } from "semantic-ui-react";
import { useApplicationConfiguration } from "../configuration/ConfigurationContext";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";

const replaceErrors = (key: string, value: any) => {
    if (value instanceof Error) {
        var error: any = {};

        Object.getOwnPropertyNames(value).forEach(function (key) {
            error[key] = (value as any)[key];
        });

        return error;
    }

    return value;
}


const getTextProps = (t: TFunction) => ({
    hideErrorMessage: t("Piilota virheilmoitus"),
    showErrorMessage: t("Näytä virheilmoitus")
})

interface IErrorMessage {
    messageProps?: MessageProps
    error?: Error
}

const ErrorMessage: React.FC<IErrorMessage> = (props) => {
    const { children, messageProps = {}, error } = props;
    const texts = getTextProps(useTranslation().t)
    const { showRawApplicationErrors } = useApplicationConfiguration();
    const [isRawErrorVisible, setRawErrorVisible] = useState(false);
    const toggleRawError = () => setRawErrorVisible(!isRawErrorVisible)

    return (
        <Message negative {...messageProps} >
            {children}
            {error && !showRawApplicationErrors ? (
                <>
                    {isRawErrorVisible ? (
                        <div style={{ width: '100%', overflowX: "scroll" }}>
                            <pre> {(error as any).error ? JSON.stringify((error as any).error, null, 2) : error instanceof Error ? JSON.stringify(error, replaceErrors, 2) : null} </pre>
                        </div>
                    ) : null}
                    <button type="button" onClick={toggleRawError}> {isRawErrorVisible ? texts.hideErrorMessage : texts.showErrorMessage}</button>
                </>
            ) : null}
        </Message >
    );
};

export default ErrorMessage;
